import React, { useMemo } from 'react';
import styled from 'styled-components/native';
import { SocketStateEnum } from '@/constants';
import { AppSpinner } from '@/components/base/app.spinner';
import { AppTextView } from '@/components/base/app.text.view';
import { Box } from '@/components/base/box';
import { useAppSelector } from '@/hooks/use.redux';
import { useUser } from '@/hooks/use.user';

function BaseConnectionStatusView({ children, enabled }: { children?: any; enabled?: boolean }) {
  const { authenticated } = useUser();
  const socketState = useAppSelector((state) => state.chatReducer.socketState);
  /*  useEffect(() => {
    if (enabled && focused) {
      setState(ChatService.getState());
    }
  }, [focused]); */

  const showConnecting = useMemo(
    () => enabled && authenticated && socketState !== SocketStateEnum.INITIAL && socketState !== SocketStateEnum.CONNECTED,
    [socketState, authenticated, enabled],
  );

  return (
    <>
      {showConnecting && <ConnectingStatusView reconnecting={socketState === SocketStateEnum.CONNECTING || socketState === SocketStateEnum.RECONNECTING} />}
      {children}
    </>
  );
}

const ConnectingStatusView = React.memo(function ConnectingStatusView({ reconnecting }: { reconnecting: boolean }) {
  return (
    <Component>
      <AppTextView textColor={'white'} text={reconnecting ? 'در حال برقراری ارتباط با سرور' : 'اتصال شما به اینترنت قطع میباشد'} />
      {reconnecting && <StatusSpinner />}
    </Component>
  );
});

const Component = styled(Box)`
  width: 100%;
  min-height: 30px;
  z-index: ${Number.MAX_SAFE_INTEGER};
  position: relative;
  top: 0;
  background-color: ${({ theme }) => theme.colors.connectionState.background};
  align-items: center;
  justify-content: center;
  flex-direction: row-reverse;
  z-index: 1;
`;

const StatusSpinner = styled(AppSpinner)`
  margin-right: 7px;
`;

export const ConnectionStatusView = React.memo(BaseConnectionStatusView);
